export default __webpack_public_path__ + "static/media/barbarian_white_icon.da7451ef.png";